<template>
  <v-menu location="bottom end">
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        data-test-id="localeSwitch"
        class="locale-switch__activator"
        variant="text"
      >
        {{ currentLocale }}
      </v-btn>
    </template>

    <v-list class="locale-switch__list" density="compact">
      <v-list-item
        v-for="localeOption in localeOptions"
        :key="localeOption"
        :data-test-id="getLocaleTestId(localeOption)"
        :active="localeOption === normalizedCurrentLocale"
        @click="switchLanguage(localeOption)"
      >
        <span class="locale-switch__option">{{ localeOption }}</span>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { i18nInstance } from '@/utils/i18n'
import type { SupportedLocale } from '@/utils/i18n'

const { locale } = useI18n()

const localeOptions: SupportedLocale[] = ['en', 'he']

const normalizedCurrentLocale = computed<SupportedLocale>(() => {
  return locale.value === 'en' ? 'en' : 'he'
})

const currentLocale = computed(() => normalizedCurrentLocale.value)

const getLocaleTestId = (localeOption: SupportedLocale) => {
  return localeOption === 'he' ? 'localeHe' : 'localeEn'
}

const switchLanguage = (localeOption: SupportedLocale) => {
  i18nInstance.switchLocale(localeOption)
}
</script>

<style lang="scss">
@use '@/assets/styles/_variables' as vars;

.locale-switch__activator,
.locale-switch__list {
  color: inherit;
  text-transform: uppercase;
}

.locale-switch__option {
  color: vars.$darkBlue;
}
</style>
